enum BiteLogType {
  Simple = 0,
  Printer = 1,
  FatalError = 4,
  Device = 5,
  // 2026-01-21: I don't want to mark this as deprecated because it would greatly complicate the
  // types, but yet we shouldn't reuse the number for new log types.
  // Delphi = 6,
  Maitred = 8,
  Pusher = 9,
  Square = 10,
  CardConnect = 11,
  Worldpay = 12,
  Kiosk = 13,
  Loyalty = 14,
  Heartland = 15,
  Stripe = 16,
  FreedomPay = 17,
  Elavon = 19,
  VerifonePointCloud = 20,
  Eigen = 21,
  Adyen = 22,
  OloPayKiosk = 23,
  VerifonePointSca = 24,
  LrsTableTracker = 25,
  Flash = 26,
  ParPay = 27,
  Chase = 28,
  Moneris = 29,
  JTechTableTracker = 30,
  Glory = 31,
  VerifoneCommander = 32,
  ExpoPrinter = 33,
  TransactCampusCard = 34,
}
export { BiteLogType };
